export enum OrderRequestStatus {
    Pending = 1,
    Invalid = 2,
    CloudProcessing = 3,
    OnPremProcessing = 4,
    Cancelled = 5
}
